export interface Participant {
  authenticated: boolean
  codigo_sap: string
  cellphone_verified: boolean
  coins: unknown[]
  cargo: string
  created_at: number
  email: string
  email_verified: boolean
  first_name: string
  celular: string
  numero_de_documento: string
  id: string
  large_picture_url: string
  last_activity_at: string
  last_name: string
  level: Record<string, unknown>
  name: string
  next_level: Record<string, unknown>
  nombre: string
  picture_url: string
  points: number
  state: string
  tags: string[]
  team: string
  team_id: string
  total_coins: unknown[]
  total_points: number
  uid: string
  uid_type: string | null
  total: number
  avatar?: string
  update_file: boolean
  staff: string
  unconfirmed_cellphone: string
  unconfirmed_email: string
}

export enum USER_TYPES {
  GERENTE = 'gerente',
  PILOTO = 'vendedor',
  SUPERVISOR = 'supervisor',
  JEFE = 'jefe',
  AGENCIA = 'agencia',
  ESCUDERIA = 'escuderia',
  SUPER_ADMIN = 'super_admin'
}

export interface User {
  uid: string
  authenticated: boolean | null
  avatar: string
  name: string
  escuderia: string
  agencia: string
  escuderiaName: string | null
  agenciaName: string | null
  zona: string | null
  email: string
  cargo: string | null
  totalUsers: number | null
  tags: string[]
  userType: USER_TYPES
  points: number
  unconfirmed_email: string
  celular: string
  numero_de_documento: string
  update_file: boolean
  total_points: number
}
